const omitBy = require('lodash/omitBy');
const isNil = require('lodash/isNil');

const replaceArrayTemplate = (string, idx = null) => {
  if (!string || !string.match(/\[\]/) || idx === null || idx === -1) {
    return string;
  }

  return string.replace(/\[\]/, `[${idx}]`);
};

const buildField = ({ sliceType, primary, items }, idx) => {
  let type,
    options,
    value;

  switch (sliceType) {
    case 'radio_button':
    case 'radio_image':
    case 'filtered_radio_image':
      type = sliceType.split('_').reverse().join('_');
      if (sliceType === 'filtered_radio_image') {
        type = 'filter_image_radio';
        primary.filterKey = replaceArrayTemplate(primary.filterKey, idx);
      }
      options = items.map(({ isPreSelected, ...item }) => {
        const option = item;

        if (isPreSelected && !value) {
          value = option.value;
        }

        if (option.image) {
          option.image = option.image.url;
        }

        return option;
      });
      break;
    default:
      // e.g. text_field => text
      type = sliceType.split('_').shift();
      break;
  }

  primary.name = replaceArrayTemplate(primary.name, idx);

  return omitBy({
    ...primary,
    value,
    options,
    type,
  }, isNil);
};

module.exports = {
  buildField,
  replaceArrayTemplate,
};
